import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button3D } from '../ui/button-3d';
import { ArrowRight } from 'lucide-react';
const CTASection: React.FC = () => {
  const navigate = useNavigate();
  return <section aria-labelledby="cta-title" className="w-full">
      <div className="mx-auto max-w-3xl text-center py-8">
        <h2 id="cta-title" className="text-2xl font-semibold tracking-tight">
          Find your perfect rental with Fiona
        </h2>
        <p className="mt-2 text-muted-foreground">Swipe, match, and message verified landlords—</p>
        <div className="mt-6 flex justify-center">
          <Button3D onClick={() => navigate('/signup')} aria-label="Get started">
            Get started
            <ArrowRight className="ms-2 h-4 w-4" aria-hidden="true" />
          </Button3D>
        </div>
      </div>
    </section>;
};
export default CTASection;